module.exports = __webpack_public_path__ + "img/photo-35.08d8e742.webp";